import React, { FC } from "react";
import { ErrorFallback } from "@/components";
import { useNavigate } from "react-router-dom";
import NotificationsBell from "./NotificationsBell";
import NotificationsList from "./NotificationsList";
import useViewportWidth from "@/hooks/useViewportWidth";
import { Button, DropdownMenu } from "@radix-ui/themes";
import { BellIcon } from "@radix-ui/react-icons";

type Props = {
  loading: boolean;
  notifications?: any;
  unreadNotifications: number;
  updateNotifications: any;
};
const NotificationsUi: FC<Props> = ({
  notifications,
  loading,
  unreadNotifications,
  updateNotifications,
}): JSX.Element => {
  const navigate = useNavigate();

  const isMobile = useViewportWidth(768);

  try {
    return (
      <>
        {!isMobile && (
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button color="gray" variant="soft" highContrast>
                <BellIcon />
              </Button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Content>
              <NotificationsList
                updateNotifications={() => updateNotifications()}
                isFullPage={false}
                notifications={notifications}
                loading={loading}
                setDropdownOpen={undefined}
                unreadNotifications={unreadNotifications}
              />
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        )}
        {isMobile && (
          <Button
            color="gray"
            variant="soft"
            highContrast
            onClick={() => navigate("/notifications")}
          >
            <BellIcon />
          </Button>
        )}
      </>
    );
  } catch {
    return <ErrorFallback />;
  }
};

export default NotificationsUi;
